
const endpoints = (id?: string | number) => {
  return {
    adminUsers: {
      createAdmin: `/admin-users`,
      getAdmins: `/admin-users`,
      getAdmin: `/admin-users/${id}`,
      updateAdmin: `/admin-users/${id}`,
      deleteAdmin: `/admin-users/${id}`,
    },
    auth: {
      login: `/auth/login`,
      logout: `/auth/logout`,
      me: `/auth/me`,
    },
    appointment: {
      getAppointmentCalender: `/appointments/date`,
      getAppointments: `/appointments`,
      getUpcomingAppointments: `/appointments/upcoming`,
      getUserAppointment: `/appointments/user/${id}`,
      getUserAppointmentByPhone: `/appointments/phone/${id}`,
      createAppointment: `/appointments/create`,
      rescheduleAppointment: `/appointments/${id}/reschedule`,
      cancelAppointment: `/appointments/${id}/cancel`,
      getPatients: `/users`,
    },
    calls: {
      getAllCall: `/calls`,
      getActiveCalls: `/calls/active`,
      getActiveCall: `/calls/${id}/live`,
      getUserCallsBId: `/calls/user/${id}`,

    },
    education: {
      getEducationContents: `/education/content`,
      generateEducationContent: `/education/content`,
      assignContentToPatients: `/education/personalized/bulk-assign-existing`,
      getPatientAssignments: `/education/personalized/assignments`,
      educationMetrics: `/education/personalized/metrics`,
    },
    reminder: {
      getReminders: `/reminders`,
    },
    roles: {
      getAvailablePermissions: `/roles/available-permissions`,
      createRole: `/roles`,
      getRoles: `/roles`,
      getRole: `/roles/${id}`,
      updateRole: `/roles/${id}`,
      deleteRole: `/roles/${id}`,
    },
    users: {
      createUser: `/users`,
      getUsers: `/users`,
      getUserById: `/users/${id}`,
      getUserByPhone: `/users/phone/${id}`,
      updateUserById: `/users/${id}`,
      getUserAppointments: `/users/${id}/appointments`,
      deleteUserById: `/users/${id}`,
      getConditions: `/users/conditions/popular`,
      getUserEducationAssignments: `/users/${id}/education`,
    },
    messaging: {
      getSMS: `/sms`,
      getSMSByUserId: `/sms/user/${id}`,
      downloadSMS: `/sms/download`,
      getEmails: `/emails`,
      getEmailsByUserId: `/emails/user/${id}`,
      downloadEmails: `/emails/download`,
    },
  };
};

export default endpoints;